import type {
  OrderShippingRequestType,
  OrderShippingResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderCreateShipment = (orderId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderShippingRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `orders/${orderId}/create-shipment`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as OrderShippingResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders, orderId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrdersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.OrderIntegrationValue,
          orderId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderIntegrationValue],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderTracking, orderId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderTracking],
      });
    },
  });
};
